<template>
  <div class="confirm" @click="closeConfirm">
    <div class="content" @click.stop>
      <div class="title">
        <span class="zh-remove" @click="closeConfirm"></span>
        {{info.title}}
      </div>
      <p v-html="info.des"></p>
      <span v-if="info.more"><a target="_blank" href="https://minisek.com/" style="color:#109eff;">
        更多了解{{info.morekey}}
      </a><br/></span>
      <!--更改客服的qq号码20220308byfgq-->
      <a target="_blank" v-if="info.status" href="http://wpa.qq.com/msgrd?v=3&uin=75829644&site=qq&menu=yes" style="color:#109eff;">
        联系客服
      </a>
      <span v-if="info.data">
       <a target="_blank"  v-for="(item,index) in info.data" :key="index" :href="item.location" style="color:#109eff;padding-right:20px">
         {{item.referenceName}}
       </a>
      </span>
    </div>
  </div>
</template>

<script>
export default {
  name: "confirm",
  props: ["info"],
  methods: {
    closeConfirm() {
      this.$emit("closeConfirm");
    }
  }
};
</script>

<style scoped lang="less">
.confirm {
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.36);
  z-index: 100;
  .content {
    position: absolute;
    background: #fff;
    overflow: hidden;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    border-radius: 8px;
    padding: 20px;
    width: 330px;
    text-align: center;
    .title {
      line-height: 30px;
      font-weight: bold;
      font-size: 20px;
      text-align: center;
      border-bottom: 1px solid #dddddd;
      padding-bottom: 10px;
      position: relative;
      span.zh-remove {
        display: inline-block;
        position: absolute;
        width: 16px;
        height: 16px;
        top: -4px;
        right: 0px;
        cursor: pointer;
      }
      span.zh-remove:before {
        display: block;
        content: "";
        position: absolute;
        right: 8px;
        width: 2px;
        height: 16px;
        background: #aaa;
        transform: rotate(-45deg);
      }
      span.zh-remove:after {
        display: block;
        content: "";
        position: absolute;
        width: 2px;
        height: 16px;
        right: 8px;
        background: #aaa;
        transform: rotate(45deg);
      }
    }
    p {
      line-height: 22px;
      padding: 14px 0;
      font-size: 16px;
      word-break:break-all
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/modules/confirm.vue